import { CONFIGURATION_BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
const axios = require("axios");
export class ConfigurationService {
  public async getAccess() {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/access`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async addAccess(accessRules: any) {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/addAccess`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(accessRules),
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async updateAccess(accessRules: any) {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/updateAccess`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(accessRules),
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async getConfigurations() {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/config`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async updateConfiguration(companyId: any, enabled: any) {
    let response = await fetch(`${CONFIGURATION_BASE_URL}/updateConfig`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ companyId: companyId, enabled: enabled }),
    });
    let ret = await response.json();
    if (!response.ok && ret && !ret.success) {
      return {
        error: ret.message,
        status: response.status,
        ok: response.ok,
      };
    }
    return ret;
  }
  public async deleteConfiguration(companyId: any) {
    let response = await fetch(
      `${CONFIGURATION_BASE_URL}/deleteConfig/${companyId}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let ret = await response.json();
    if (!response.ok && ret && !ret.success) {
      return {
        error: ret.message,
        status: response.status,
        ok: response.ok,
      };
    }
    return ret;
  }
  public async editConfiguration(imageItem: any, companyId: any) {
    let response = await fetch(
      `${CONFIGURATION_BASE_URL}/editConfig/${companyId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(imageItem),
      }
    );
    let ret = await response.json();
    if (!response.ok && ret && !ret.success) {
      return {
        error: ret.message,
        status: response.status,
        ok: response.ok,
      };
    }
    return ret;
  }
  public async addConfig(imageItem: any) {
    let response = await fetch(`${CONFIGURATION_BASE_URL}/addConfig`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(imageItem),
    });
    let ret = await response.json();
    if (!response.ok && ret && !ret.success) {
      return {
        error: ret.message,
        status: response.status,
        ok: response.ok,
      };
    }
    return ret;
  }

  public async uploadFile(multipleFiles: any) {
    var formData = new FormData();
    multipleFiles.forEach((file: any) => { formData.append("file", file) });
    const config = { headers: { "content-type": "multipart/form-data" } };
    let response = await axios.post(
      `${CONFIGURATION_BASE_URL}/files/upload`,
      formData,
      config
    );
    let ret = response.data;
    if (!ret.success) {
      return {
        error: ret.message,
        status: response.status,
        ok: response.ok,
      };
    }
    return ret;
  }

  public async deleteFile(fileName: String) {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/files/delete`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          filename: fileName.toString(),
          "Content-Type": "application/json",
        }
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }


  public async downloadFile(fileName: String) {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/files/download`, {
        method: "GET",
        headers: {
          filename: fileName.toString(),
        },
      });
      if (response.status === 204) {
        return { error: true, message: "File not found" };
      }
      let ret = await response.blob();
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async getFileName() {
    try {
      let response = await fetch(`${CONFIGURATION_BASE_URL}/files/names`, {
        method: "GET",
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

}
